export const orderPanelStyles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 2,
		padding: '12px',
		bgcolor: '#f5f5f5',
		marginTop: '56px',
	},
	ordersBox: {
		display: 'flex',
		flexDirection: 'column',
		maxWidth: '500px',
		width: '100%',
		gap: 2,
		flex: 1,
	},
	orderCard: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		background: '#fff',
		borderRadius: '24px',
		p: 2.5,
		boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		mb: 0.5,
	},
	title: {
		fontSize: '18px',
		fontWeight: 'medium',
		flex: 1,
	},
	chip: {
		backgroundColor: '#4CAF50',
		color: 'white',
		fontWeight: 500,
		borderRadius: '20px',
		height: '32px',
	},
	tagChip: {
		backgroundColor: '#f44336',
		color: 'white',
		fontWeight: 500,
		borderRadius: '20px',
		height: '32px',
	},
	statusChip: {
		color: '#fff',
		background: '#6C757D',
		fontWeight: 500,
		borderRadius: '20px',
		height: '32px',
	},
	total: {
		color: '#4CAF50',
		fontSize: '28px',
		fontWeight: 500,
		textAlign: 'center',
		mb: 2,
	},
	addressBox: {
		borderTop: '1px solid #e0e0e0',
		borderBottom: '1px solid #e0e0e0',
		py: 2,
		mb: 2,
		textAlign: 'right',
	},
	paymentInfo: {
		textAlign: 'right',
		mb: 2,
		px: 1,
		'& > p': {
			fontSize: '15px',
			lineHeight: 1.5,
		},
	},
	photoBox: {
		display: 'flex',
		justifyContent: 'flex-end',
		mb: 2,
		px: 1,
	},
	imgContainer: {
		width: '100px',
		height: '100px',
		'& img': {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
			borderRadius: '8px',
			display: 'block',
		},
	},
	actionIcons: {
		display: 'flex',
		justifyContent: 'left',
		alignItems: 'center',
		gap: 1,
	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	modalContent: {
		bgcolor: 'background.paper',
		borderRadius: 2,
		p: 3,
		width: '90%',
		maxWidth: 400,
		maxHeight: '80vh',
		overflow: 'auto',
	},
	modalButtonContainer: {
		mt: 3,
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 2,
	},
	producerName: {
		fontSize: '16px',
		fontWeight: 'medium',
	},
	pendingStatus: {
		fontSize: '14px',
	},
	completedStatus: {
		fontSize: '14px',
	},
	tagContainer: {
		display: 'flex',
		gap: 1,
		mb: 3,
	},
	emptyMessage: {
		fontSize: '16px',
		fontWeight: 'medium',
		textAlign: 'center',
		mt: 3,
	},
}

